import { snakeCase } from "lodash";

function toSnakeCase() {
  return {
    restrict: "A",
    scope: {
      ngModel: "=",
    },
    link: (scope) => {
      scope.$watch("ngModel", (newVal) => {
        const trimmedNewValue = newVal?.trim();
        if (trimmedNewValue) {
          scope.ngModel = snakeCase(trimmedNewValue);
        }
      });
    },
  };
}

export default toSnakeCase;
